import { Box, Modal } from '@mui/material';
import Button from '../../../../../../components/Button/Button';
import RecentProjects from '../../../../../MACRA_1/components/recentProjects/RecentProjects';
import { modalStyle } from '../../../../../style/modal';
import { IModalProjectsProps } from './IModalProjects';

const ModalProjects = (props: IModalProjectsProps) => {
    const handleClose = () => {
        props.onClose();
    };

    return (
        <Modal open={props.open} onClose={handleClose}>
            <Box sx={modalStyle}>
                <RecentProjects onClose={handleClose} />
                <div className='d-flex justify-content-start mt-3'>
                    <Button onClick={handleClose}>Close</Button>
                </div>
            </Box>
        </Modal>
    );
};

export default ModalProjects;
